import { AbstractControl, ValidationErrors } from '@angular/forms';

import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';

export const noDuplicateValidator$ = (
  arr$: Observable<any>,
  findDuplicates?: (item: any, value: any) => boolean,
) => {
  const compare = findDuplicates || ((item: any, value: any) => item === value);

  return (control: AbstractControl): Observable<ValidationErrors | null> =>
    arr$.pipe(
      map((arr: any[]) => {
        const hasDuplicate = !!arr.filter(item => compare(item, control.value)).length;
        return hasDuplicate ? { duplicate: true } : null;
      }),
      first(),
    );
};
